import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';
import { mapStateToProps, mapDispatchToProps } from '../../utils';

import { updateAppState } from '../../actions/applicationState';

import Body from '../../components/Body';
import UnauthenticatedHeader from '../../components/UnauthenticatedHeader';
import Footer from '../../components/Footer';

class UnauthenticatedContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.openLoginHandler = this.loginModalOpenHandler.bind(this);
  }

  loginModalOpenHandler() {
    this.props.dispatch(updateAppState({
      login_modal_open: true,
    }));
  }

  render() {
    return (
      <Body hasFooter>
        <UnauthenticatedHeader openLoginHandler={this.openLoginHandler} />
        <div className={css(styles.container)}>
          {this.props.children}
        </div>
        <Footer user={false} />
      </Body>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    paddingTop: Theme.navigation.height,
  },
});

UnauthenticatedContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  dispatch: PropTypes.func.isRequired,
};

UnauthenticatedContainer.defaultProps = {
  children: [],
};

export default connect(mapStateToProps, mapDispatchToProps)(UnauthenticatedContainer);



// WEBPACK FOOTER //
// ./src/views/UnauthenticatedContainer/index.js